module.exports = __webpack_public_path__ + "static/img/13_pro.c2ab350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/13_pro.jpg
// module id = LbHk
// module chunks = 0